import { useRef } from "react";
import { useVirtualizer } from "@tanstack/react-virtual";
import * as React from "react";
import { Box, Flex, useBreakpointValue } from "@chakra-ui/react";
import { AnswerCard } from "./index";

function AnswersVirtualizedList({ items }) {
  const parentRef = useRef(null);
  const rowHeight = useBreakpointValue({ xl: 140, base: 190 });

  const virtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => rowHeight,
    enabled: true
  });

  const virtualItems = virtualizer.getVirtualItems();

  return (
    <Box
      ref={parentRef}
      style={{
        height: rowHeight * items.length,
        maxHeight: 450,
        overflowY: "auto",
        contain: "strict"
      }}
    >
      <Box
        style={{
          height: virtualizer.getTotalSize(),
          width: "100%",
          position: "relative"
        }}
      >
        <Box
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            transform: `translateY(${virtualItems[0]?.start ?? 0}px)`
          }}
        >
          {virtualItems.map((virtualRow) => {
            const dataItem = items[virtualRow.index];

            return <Box
              key={virtualRow.key}
              data-index={virtualRow.index}
              ref={virtualizer.measureElement}
            >
              <Flex
                width="100%"
                padding={2}
                alignItems="center"
              >
                <AnswerCard data={dataItem} />
              </Flex>
            </Box>;
          })}
        </Box>
      </Box>
    </Box>
  );
}

export default AnswersVirtualizedList;